import Vue from "@/main";
import { set } from "lodash";

export let graphicLayer;
let graphicData;

export function createdGraphicLayer() {
  graphicLayer = new mars3d.layer.GraphicLayer();
  Vue.$GLOBAL.map.addLayer(graphicLayer);

  bindLayerContextMenu();
}

// graphicLayer.on(mars3d.EventType.click, function(event) {
//   setEditor(event);
// });

export function addDemoGraphic(style, position) {
  let graphic = new mars3d.graphic.ModelPrimitive({
    // name: "汽车",
    position: position,
    style: style,
  });
  graphicLayer.addGraphic(graphic);
}

export function hideModel(position) {
  graphicLayer.eachGraphic((graphic) => {
    if (graphic && position[0] == graphic._point._lng) {
      graphicLayer.removeGraphic(graphic);
    }
  });
}

export function editModel(e) {
  let p = JSON.parse(e.position);
  graphicLayer.eachGraphic((graphic) => {
    if (graphic._point._lng == p[0]) {
      graphicData = graphic;
    }
  });
}
export function getEditModel(e) {
  let p = JSON.parse(e.position);
  let data;
  graphicLayer.eachGraphic((graphic) => {
    if (graphic._point._lng == p[0]) {
      data = graphic.toGeoJSON();
    }
  });
  return data;
}
export function set_editModel(obj) {
  graphicData.setStyle(obj);
}
export function to_vectorData(e) {
  let position = JSON.parse(e.position);
  let style = JSON.parse(e.graphic).style;
  let isShow = false;
  let g = null;
  graphicLayer.eachGraphic((graphic) => {
    if (graphic._point._lng == position[0]) {
      isShow = true;
      g = graphic;
    }
  });
  if (isShow) {
    Vue.$GLOBAL.map.flyToGraphic(g, { radius: 300 });
  } else {
    style.opacity = 0;
    let graphic = new mars3d.graphic.ModelPrimitive({
      position: position,
      style: style,
    });
    graphicLayer.addGraphic(graphic);
    Vue.$GLOBAL.map.flyToGraphic(graphic, { radius: 300 });
    setTimeout(() => {
      graphicLayer.removeGraphic(graphic);
    }, 200);
  }
}

// 绑定右键菜单
export function bindLayerContextMenu() {
  graphicLayer.bindContextMenu([
    {
      text: "删除对象",
      icon: "fa fa-trash-o",
      show: (event) => {
        const graphic = event.graphic;
        if (!graphic || graphic.isDestroy) {
          return false;
        } else {
          return true;
        }
      },
      callback: (e) => {
        const graphic = e.graphic;
        if (!graphic) {
          return;
        }
        const parent = graphic.parent; // 右击是编辑点时
        graphicLayer.removeGraphic(graphic);

        if (parent) {
          graphicLayer.removeGraphic(parent);
        }
      },
    },
  ]);
}
